
<app-compose-mail appendTo='body' style="z-index: 9999999;" ></app-compose-mail>
<div *ngIf="selectedInvoice" style="margin: 5px">
  <form [formGroup]="invoiceForm" (ngSubmit)='saveInvoice()'>
    <p-toast [style]="{marginTop: '80px'}" position="top-center" key="tc"></p-toast>


    <div class="row">
      <div class="col-3">Invoice No. <strong>{{selectedInvoice.numeroFiche}}</strong>
        <span *ngIf="!selectedInvoice.numeroFiche" class="text-muted"> {{selectedInvoice.idfacture}}</span></div>
      <div class="col-9">
        <span *ngIf="invoiceForm.touched || invoiceForm.dirty" style="color: orange;background: midnightblue">Veuillez
          sauvgarder les modification</span>
        <button mat-flat-button color="warn" [hidden]='invoiceForm.invalid || selectedInvoice.numeroFiche ||  invoiceForm.touched || invoiceForm.dirty'
          type="button" class="pull-right" (click)="valider()" style="margin: 3px">
          <mat-icon>done_outline</mat-icon>
          Validate invoice
        </button>&nbsp;

        <button mat-stroked-button color="default" class="pull-right" [disabled]='!invoiceForm.touched && !invoiceForm.dirty'
          type="submit" style="margin: 3px">
          <mat-icon>save</mat-icon>Save
        </button>&nbsp;

        <button mat-stroked-button color="accent" class="pull-right" type="button" [hidden]='invoiceForm.invalid  ||  invoiceForm.touched || invoiceForm.dirty'
          (click)="printInvoice()" style="margin: 3px">
          <mat-icon>print</mat-icon> Print
        </button>&nbsp;

        <button mat-stroked-button color="primary" class="pull-right" [matMenuTriggerFor]="appMenu" type="button"
          [hidden]='invoiceForm.invalid  ||  invoiceForm.touched || invoiceForm.dirty' style="margin: 3px">
          <mat-icon>more_horiz</mat-icon> More
        </button>&nbsp;
        <mat-menu #appMenu="matMenu">
          <button  (click)="ismail=true;sendFacture()" mat-menu-item>
            <mat-icon>send</mat-icon> Send
          </button>
          <button mat-menu-item (click)="displayTTC=true">
            <mat-icon>apps</mat-icon>Calcul HT
          </button>
          <button mat-menu-item (click)="displayPerso=true">
            <mat-icon>  brush</mat-icon>Customize print
          </button>
        </mat-menu>



      </div>



    </div>

    <div class="row">
      <div class="col-6">

        <mat-card>


          <mat-form-field class="full-width">
            <input type="text" placeholder="Customer Invoicing Company" [matAutocomplete]="auto" aria-label="Number"
              matInput formControlName="billingCompany">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option *ngFor="let customer of customers | async" [value]="customer" (onSelectionChange)='changeCBC(customer)'>
                {{customer.raisonSocial}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>


          <mat-form-field class="full-width">
            <mat-select placeholder="Contact" formControlName="contactSelect" [compareWith]="compareFn"
             [(ngModel)]="selectedInvoice.contactcontactId">
              <mat-option *ngFor="let item of contacts | async" [value]="item">
                {{item.nom}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="full-width">
            <input matInput type="tel" formControlName="tel" placeholder="Tel" [(ngModel)]="selectedInvoice.contactcontactId.tel">

            <mat-error>Tel is required</mat-error>

          </mat-form-field>
          <mat-form-field class="full-width">
            <input matInput placeholder="E-Mail" formControlName="mail" [(ngModel)]="selectedInvoice.contactcontactId.mail">
            <mat-error>E-mail is required</mat-error>
          </mat-form-field>
        </mat-card>
      </div>
      <div class="col-6">

        <mat-card>


          <div class="full-width">


            <mat-form-field style="width: 40%">
              <input matInput [matDatepicker]="dateInvoice" formControlName="dateInvoice" [(ngModel)]="selectedInvoice.datefacture"
                placeholder="Invoice Date">
              <mat-datepicker-toggle matSuffix [for]="dateInvoice"></mat-datepicker-toggle>
              <mat-datepicker #dateInvoice></mat-datepicker>
              <mat-error>Date is required</mat-error>
            </mat-form-field>&nbsp;
            <mat-form-field style="width: 40%">
              <input matInput [matDatepicker]="sentDate" formControlName="sentDate" [(ngModel)]="selectedInvoice.dateenvoicontrat"
                placeholder="Sent Date">
              <mat-datepicker-toggle matSuffix [for]="sentDate"></mat-datepicker-toggle>
              <mat-datepicker #sentDate></mat-datepicker>
            </mat-form-field>
          </div>
          <mat-form-field style="width: 40%">
            <mat-select placeholder="Company Name" formControlName="company" [compareWith]="compareSociFact"
              [(ngModel)]="selectedInvoice.sociFactSociFactId">
              <mat-option *ngFor="let item of socifacts | async" [value]="item">
                {{item.designation}}
              </mat-option>
            </mat-select>
            <mat-error>Company Name is required</mat-error>
          </mat-form-field>&nbsp;
          <mat-form-field style="width: 40%">
            <mat-select placeholder="Currency" formControlName="currency" [(ngModel)]="selectedInvoice.devise"
              (selectionChange)='changeDevise()'>
              <mat-option *ngFor="let item of devises " [value]="item">
                {{item }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="full-width">
            <mat-slide-toggle [(ngModel)]="selectedInvoice.tva" formControlName="tva"> TVA </mat-slide-toggle> &nbsp;
            <mat-slide-toggle [(ngModel)]="selectedInvoice.timbre" formControlName="timbre"> Timbre </mat-slide-toggle>
            &nbsp;
            <mat-slide-toggle [(ngModel)]="selectedInvoice.finance" formControlName="finance">   Espéce </mat-slide-toggle> &nbsp;
          
            <mat-slide-toggle [(ngModel)]="selectedInvoice.annuler" formControlName="annuler">   Annulée </mat-slide-toggle> &nbsp;
          </div>




          <mat-form-field class="full-width">
            <textarea matInput [(ngModel)]="selectedInvoice.observation" formControlName="observation" placeholder="Notes"
              rows="3"></textarea>
          </mat-form-field>
        </mat-card>
      </div>

    </div>
  </form>

  <br />
  <mat-card>

    <mat-slide-toggle *ngIf="!editFacturDetails"   [(ngModel)]="editFacturDetails">Editable</mat-slide-toggle>
    <button mat-raised-button *ngIf="editFacturDetails" (click)="saveList()">Save List</button>

    <button mat-raised-button color="warn" *ngIf="editFacturDetails" (click)="cancelList()">Cancel </button>
    <button mat-stroked-button color="primary"   style="margin: 3px" type="button"
    (click)="openDialog()">
    <mat-icon>add</mat-icon> Add products
  </button>
<div class="row">
  <mat-table #table style="width: 100%;" [dataSource]="dataSource" >


    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef style="width: 60px;margin-right: 5px"> </th>
      <td mat-cell *matCellDef="let element">
        <button (click)="removeDetail(element)"  mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>




    <ng-container matColumnDef="designation">
      <th mat-header-cell *matHeaderCellDef style="width: 70%">Designation </th>
      <td mat-cell *matCellDef="let element">


        <span *ngIf="!editFacturDetails">{{element.designation}}</span>

        <textarea matInput *ngIf="editFacturDetails" rows="2" [(ngModel)]="element.designation"></textarea>
      </td>
    </ng-container>

    <ng-container matColumnDef="prixunit">
      <th mat-header-cell *matHeaderCellDef style="width: 10%">Prix Unitaire </th>
      <td mat-cell *matCellDef="let element">
        <input matInput [(ngModel)]="element.prixunit" *ngIf="editFacturDetails" currencyMask >
        <span *ngIf="!editFacturDetails">{{element.prixunit| currency: ' '}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="quantite">
      <th mat-header-cell *matHeaderCellDef style="width: 10%">Quantité </th>
      <td mat-cell *matCellDef="let element">
        <input type="number" style="margin-left: 20px;width: 50px" matInput [(ngModel)]="element.quantite" *ngIf="editFacturDetails">

        <span *ngIf="!editFacturDetails">{{element.quantite}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="remise">
      <th mat-header-cell *matHeaderCellDef style="width: 10%">Remise </th>
      <td   mat-cell *matCellDef="let element">
        <input matInput [(ngModel)]="element.remise" style="margin-left: 20px;width: 50px" *ngIf="editFacturDetails"
          currencyMask >

        <span *ngIf="!editFacturDetails">{{element.remise| currency: ' '}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="stotal">
      <th mat-header-cell *matHeaderCellDef style="width: 100px">S.Total </th>
      <td mat-cell *matCellDef="let element">

        {{ element.prixunit *element.quantite - element.remise | currency: ' '}}
      </td>
    </ng-container>
    <tr  mat-header-row *matHeaderRowDef="displayedColumns "></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </mat-table>
 
</div>


  <div style="width: 50%;float: left;margin: 5px;padding: 40px" class="mat-elevation-z2">
    <strong>Montant A payer<span style="color:red"> {{selectedInvoice.montantttc | currency:  ' ' }} {{selectedInvoice.devise | uppercase}}</span></strong>
  </div>
  <table style="width: 30%;float: right;margin: 5px;" class="mat-elevation-z8">
    <tr>
      <td>
        Total HT:
      </td>
      <td>
     <span style="font-weight: bolder;">{{selectedInvoice.montantotal | currency: ' '}}</span>   
      </td>
    </tr>
    <tr>
      <td>
        Total Remise:
      </td>
      <td>
        <span style="font-weight: bolder;">    {{selectedInvoice.montantremise | currency: ' '}}</span>   
      </td>
    </tr>

    <tr>
      <td>
        Total TTC:
      </td>
      <td>
     <b> {{totalTTC | currency: ' '}}</b>  
      </td>
    </tr>
  </table>


  <table style="width: 30%;float: right;margin: 5px;" class="mat-elevation-z8">
    <tr>
      <td>
        Mode Paiement:
      </td>
      <td>
    
        <mat-form-field>
          <mat-select placeholder="Select" [(ngModel)]="selectedInvoice.typePaiement"  (selectionChange)="changeMode($event.value)">
            <mat-option value="cheque">Chéque</mat-option>
            <mat-option value="virement">Virement</mat-option>
            <mat-option value="cash">En espèces</mat-option>
            <mat-option value="terme">A terme</mat-option>


          </mat-select>
        </mat-form-field>
      </td>
    </tr>
    <tr>
      <td>
     
      </td>
      <td>
        <mat-form-field style="width: 40%" *ngIf="selectedInvoice.typePaiement=='terme'">
          <input matInput [matDatepicker]="dueDate" [(ngModel)]="selectedInvoice.dateEcheance" (dateChange)='saveInvoice()'
            placeholder="Due Date">
          <mat-datepicker-toggle matSuffix [for]="dueDate"></mat-datepicker-toggle>
          <mat-datepicker #dueDate></mat-datepicker>
        </mat-form-field>
      </td>
      </tr>
    </table>



  <div style="width: 50%;float: left;margin: 5px;padding: 40px" class="mat-elevation-z2">
    <strong>TVA:<span style="color:red"> {{montantTva | currency:  ' ' }} {{selectedInvoice.devise | uppercase}}</span> <br />

      Droit de timbre:<span style="color:red"> {{montantTimbre | currency:   ' ' }} {{selectedInvoice.devise | uppercase}}</span></strong>
  </div>

</mat-card>

  <p-dialog header="Calcul HT" [(visible)]="displayTTC" modal="true" appendTo='body'>

    <mat-form-field>
      <input matInput placeholder="Prix TTC" type="number" (input)="calculerHT()" (blur)="calculerHT()" [(ngModel)]="calcTTC">
    </mat-form-field><br />
    <mat-form-field>
      <input matInput placeholder="TVA" readonly='false' type="number" [(ngModel)]="calcTVA">
    </mat-form-field><br />
    <mat-form-field>
      <input matInput placeholder="Prix HT" readonly='false' type="number" [(ngModel)]="calcHT">
    </mat-form-field><br />
  </p-dialog>


  <p-dialog header="Impression personalisé" [(visible)]="displayPerso" modal="true" [width]='500' appendTo='body'>

    <mat-slide-toggle [(ngModel)]="isAnglais"  > Anglais </mat-slide-toggle>  <br />
    <mat-slide-toggle [(ngModel)]="isSignature"  > Signature </mat-slide-toggle> <br />

    <mat-form-field style="width: 100%">
      <textarea matInput placeholder="Text au-dessous N° Facture" [(ngModel)]="textc1"></textarea>
    </mat-form-field> <br />
    <mat-form-field style="width: 100%">
      <textarea matInput placeholder="Text au-dessous Adresse" [(ngModel)]="textc2"></textarea>
    </mat-form-field> <br />
    <mat-form-field style="width: 100%">
      <textarea matInput placeholder="Text au-dessous Montant lettre" [(ngModel)]="textc3"></textarea>
    </mat-form-field> <br />
    
    <button mat-stroked-button color="primary" class="pull-right" type="button" [hidden]='invoiceForm.invalid  ||  invoiceForm.touched || invoiceForm.dirty'
    (click)="exportWord()" style="margin: 3px">
    <mat-icon>cloud_download</mat-icon> Export Word </button>
    <button mat-stroked-button color="accent" class="pull-right" type="button" [hidden]='invoiceForm.invalid  ||  invoiceForm.touched || invoiceForm.dirty'
    (click)="printInvoiceP()" style="margin: 3px">
    <mat-icon>print</mat-icon> Print
  </button>
  </p-dialog>

<style>
    ::ng-deep #inparticipe tr.mat-header-row{
        width: 100%!important;
        }
        
        ::ng-deep #inparticipe .mat-card{
     font-family: inherit;
        }
</style>
</div>